import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { meta } from "../../content_option";
import { Container, Row } from "react-bootstrap";
import { BASE_URL } from "../../http/urls";
// import faq from "../../assets/videos/Gif.mp4";
import faq from "../../assets/videos/Shannen Ornage Comp.mp4";
import axios from "axios";

import Footer from "../../components/footer";
import "./style.css";

export const Videography = () => {
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addOns, setAddOns] = useState([]);

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}api/v1/getevent?shootType=video`
        );
        setEventData(response.data.data.events);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch event data");
        setLoading(false);
      }
    };

    fetchEventData();
  }, []);

  useEffect(() => {
    const fetchAddOns = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/v1/listAdd?shootType=video`);
        console.log("AddOns API response:", response.data.data.events);
        setAddOns(response.data.data.events);
      } catch (error) {
        console.error("Failed to fetch addOns:", error);
        setAddOns([]);
      }
    };
    fetchAddOns();
  }, []);

  const rightColumnAddOns = addOns.slice(0,Math.ceil(addOns.length / 2));
 const leftColumnAddOns = addOns.slice(Math.ceil(addOns.length / 2));

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Investment | {meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <div className="videoclass">
        <video
          src={faq}
          autoPlay
          loop
          muted
          className="vid"
          style={{
            width: "100%",
            objectFit: "cover",
            zIndex: "-1",
            top: 0,
          }}
        ></video>
      </div>

      <Container style={{ marginTop: "20px", marginTop: "70px" }}>
        <Row
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "30px",
          }}
          className="for-space-only"
        >
          <h2 className="faq">Videography Package</h2>
        </Row>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="test-container ">
            <div>
              <p>
                At Made In Heaven, we know that every part of your wedding
                journey holds significance. Our videography package is crafted
                to provide you with the flexibility to choose the coverage that
                best suits your vision, allowing you to select the hours for
                each event, no matter how big or small. We’re here to film all
                the pre-wedding events you want us to capture, documenting each
                with the skill and care it deserves. This package includes
                options for 2-hour and 3-hour pre-wedding events, each priced as
                shown below. For any additional time, we offer an extended
                hourly rate of $400/hour, so you can enjoy seamless, complete
                coverage of your celebrations.
              </p>
            </div>
          </div>
          {loading && <p>Loading events...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {!loading && !error && eventData && eventData.length > 0 && (
            <div
              className="mt-3 table-container"
              style={{
                width: "70%",
                borderRadius: "15px",
                overflow: "hidden",
                border: "1px solid #dee2e6",
              }}
            >
              <div
                className="table-header"
                style={{
                  display: "flex",
                  backgroundColor: "#f8f9fa",
                  fontWeight: "bold",
                }}
              >
                <div
                  className="table-cell"
                  style={{
                    flex: 2,
                    padding: "10px",
                    borderRight: "1px solid #dee2e6",
                  }}
                >
                  Event Name
                </div>
                <div
                  className="table-cell"
                  style={{
                    flex: 1,
                    padding: "10px",
                    borderRight: "1px solid #dee2e6",
                  }}
                >
                  Hours
                </div>
                <div
                  className="table-cell"
                  style={{ flex: 1, padding: "10px" }}
                >
                  Price
                </div>
              </div>
              {eventData.map((event, idx) => (
                <div
                  className="table-row"
                  key={event._id || idx}
                  style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
                >
                  <div
                    className="table-cell"
                    style={{
                      flex: 2,
                      padding: "10px",
                      borderRight: "1px solid #dee2e6",
                    }}
                  >
                    {event.name || "N/A"}
                  </div>
                  <div
                    className="table-cell"
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRight: "1px solid #dee2e6",
                    }}
                  >
                    {event.hours || "N/A"}
                  </div>
                  <div
                    className="table-cell"
                    style={{ flex: 1, padding: "10px" }}
                  >
                    ${event.price || "N/A"}
                  </div>
                </div>
              ))}
            </div>
          )}
          {/* <div
            className="mt-3 table-container"
            style={{
              width: "70%",
              borderRadius: "15px",
              overflow: "hidden",
              border: "1px solid #dee2e6",
            }}
          >
            <div
              className="table-header"
              style={{
                display: "flex",
                backgroundColor: "#f8f9fa",
                fontWeight: "bold",
              }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Event
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px" }}>
                Price
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Each Pre-wedding events (Mehndi, Churra, etc)
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                2 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px" }}>
                $900
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Each Pre-wedding events (Sangeet, Jaggo etc)
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                3 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px" }}>
                $1300
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Wedding Ceremony
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                12 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px" }}>
                $7000
              </div>
            </div>
            <div
              className="table-row"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Reception
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                5 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px" }}>
                $2800
              </div>
            </div>
            <div
              className="table-row new"
              style={{ display: "flex", borderTop: "1px solid #dee2e6" }}
            >
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                Engagement
              </div>
              <div
                className="table-cell"
                style={{
                  flex: 1,
                  padding: "10px",
                  borderRight: "1px solid #dee2e6",
                }}
              >
                4 hours
              </div>
              <div className="table-cell" style={{ flex: 1, padding: "10px" }}>
                $1800
              </div>
            </div>
          </div> */}
          </div>
          <div>
            <div
              className="deliverables mt-3 mb-3 "
              style={{ lineHeight: "1", fontFamily: "Crimson Text, serif" }}
            >
              <h4
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textTransform: "uppercase",
                  marginBottom: "20px",
                }}
              >
                Deliverables
              </h4>
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                Long Documentary Edit for Pre-wedding events
              </p>
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                Long Documentary Edit for Wedding
              </p>
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                Long Documentary Edit for Reception
              </p>
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                Drone for Wedding Day
              </p>
            </div>

            {/* <div
            className="add-ons"
            style={{ marginTop: "25px", textTransform: "uppercase" }}
          >
            <h4
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              Add Ons:
            </h4>
            <div className="final" style={{ display: "flex", justifyContent: "space-between", fontFamily: "Crimson Text, serif" }}>
              <div
                className="add-ons-list"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Next Day Edit (Signature) – $1500
                </div>
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Next Day Edit (Classic) - $850
                </div>
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Pre-shoot: $1500 (One Instagram Reel + Drone)
                </div>
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Feature Film (2-3 hours): $1200
                </div>
              </div>
              <div
                className="add-ons-list"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Highlight (Reception added to the NDE): $350
                </div>
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Instagram Reel - $250
                </div>
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Baby Slideshow - $250
                </div>
                <div
                  className="add-on-item"
                style={{
                  padding: "10px",
                  border: "1px solid #dee2e6",
                  borderRadius: "5px",
                  backgroundColor: "#f8f9fa",
                }}
                >
                  Family Interview - $850
                </div>
                <div
                  className="add-on-item"
                  // style={{
                  //   padding: "10px",
                  //   border: "1px solid #dee2e6",
                  //   borderRadius: "5px",
                  //   backgroundColor: "#f8f9fa",
                  // }}
                >
                  Groom Family Interviews - $650
                </div>
              </div>
            </div> */}

            {/* Add-ons section */}
          <div
            className="add-ons"
            style={{ marginTop: "25px", textTransform: "uppercase", width: "100%" }}
          >
            <h4
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: "20px", // Added some bottom margin for spacing
              }}
            >
              Add Ons:
            </h4>
            {/* Conditional rendering for add-ons */}
            {addOns.length === 0 ? (
              <p style={{ textAlign: "center" }}>No add-ons available or loading...</p>
            ) : (
              <div
                className="final"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontFamily: "Crimson Text, serif",
                  flexWrap: "wrap", // Allow wrapping on smaller screens if needed
                }}
              >
                <div className="add-ons-list-right" style={{ textAlign: "left", flex: 1, minWidth: "300px", marginRight: "20px" }}>
                  {rightColumnAddOns.map((addon, idx) => (
                    <div className="add-on-item" key={addon._id || idx} style={{ marginBottom: "5px" }}>
                      {/* Assuming your API returns 'name' and 'price' for add-ons */}
                      {addon.title}: ${addon.price}
                    </div>
                  ))}
                </div>
                <div className="add-ons-list-left" style={{ textAlign: "left", flex: 1, minWidth: "300px", marginRight: "-200px" }}>
                  {leftColumnAddOns.map((addon, idx) => (
                    <div className="add-on-item" key={addon._id || idx} style={{ marginBottom: "5px" }}>
                      {/* Assuming your API returns 'name' and 'price' for add-ons */}
                      {addon.title}: ${addon.price}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          className="description "
          style={{ marginTop: "20px", marginBottom: "70px" }}
        >
          <p>
            Let us work together to create a tailored videography package that
            brings your dream wedding to life, offering you the freedom to
            relive each moment in vivid detail from start to finish.
          </p>
        </div>
      </Container>

      <Footer />
    </HelmetProvider>
  );
};

export default Videography;
